/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import { GenericType } from "@/types";
import { RequiredInput } from "@/components/shared/required-input";
import { PermissionInput } from "../permission-input";
import { useEffect, useMemo } from "react";
// import { useWatch } from "react-hook-form";

type UserFormType = {
  formData: GenericType;
  onOpenChange: (prop: GenericType) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  currentUser: any;
  companyData: any;
  company_id: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  currentUser,
}: // company_id,
UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  const isRoleDisabled = useMemo(() => {
    if (!formData?.role_id) {
      return false;
    }
    if (currentUser.role_id === formData?.role_id) {
      return true;
    }
    return false;
  }, [currentUser?.role_id, formData?.role_id]);

  useEffect(() => {
    if (open === false) {
      form.reset();
    }
  }, [open]);

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
            <FormField
              control={form.control}
              name="role_name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>
                    Role name
                    <RequiredInput />
                  </FormLabel>
                  <FormControl>
                    <Input
                      autoComplete="off"
                      placeholder="Role name"
                      {...field}
                      // disabled={formData ? true : false}
                    />
                  </FormControl>

                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="description"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Description</FormLabel>
                  <FormControl>
                    <Input placeholder="Description" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="col-span-full">
              <FormField
                control={form.control}
                name="permission"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <PermissionInput
                        value={field.value}
                        onChange={field.onChange}
                        isRoleDisabled={isRoleDisabled}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
            </div>
          </div>
          <hr className="mt-5" />
          <DialogFooter className="p-6 flex !justify-start">
            <Button
              type="submit"
              className="w-[150px]"
              disabled={form.formState.isSubmitting}
            >
              {form.formState.isSubmitting ? (
                <IconRender
                  name="LoaderCircle"
                  className="w-5 animate-spin text-white zoom-in-150"
                />
              ) : (
                "Save"
              )}
            </Button>
            <Button
              type="submit"
              onClick={() => onOpenChange(false)}
              variant={"outline"}
              className="w-[150px]"
            >
              Close
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </>
  );
};
